module.exports = __webpack_public_path__ + "img/banner.8fa1035e.png";